<script>
    import { metaInfo } from "@/core/MetaInfo";
    import CertificatesInfo from "@/components/CertificatesInfo";

    export default {
        name: "Certificates",
        components: { CertificatesInfo },
        metaInfo() {
            return metaInfo.getMeta("certificates");
        },
    };
</script>

<template>
    <certificates-info name="Picooc" url="picooc.ru"></certificates-info>
</template>

<style lang="scss">
    @import "~@picooc/assets/sass/typography.scss";
</style>
